module.exports = __webpack_public_path__ + "media/Plasticos.bc6ce576.mp4";